export enum ServiceTypeEnum {
  annual = "annual",
  onDemand = "onDemand",
}

export const serviceTypeEnumValues = Object.values(ServiceTypeEnum);
export const serviceTypeEnumLabelMap: Record<ServiceTypeEnum, string> = {
  [ServiceTypeEnum.onDemand]: "On Demand",
  [ServiceTypeEnum.annual]: "Flat Rate",
};

export const serviceTypeSelectOptions = serviceTypeEnumValues.map((c) => ({
  label: serviceTypeEnumLabelMap[c],
  value: c,
}));
